import "../../../resources/fonts/fonts.css"

    export const CenterCardStyles = {
        height: "80vh",
        width: "95vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1",
        opacity: "0.75"
    }
    export const CenterTextStyles = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        textAlign: "center",
        position: "absolute",
        zIndex: "1"
    }
    export const SpinningGearsStyles = {
        zIndex: "-1",
        opacity: "0.5"
    }
